const actionarrowBack = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="13.9994375 8 12.9419706 6.94253305 8.74978907 11.1274023 8.74978907 2 7.24964845 2 7.24964845 11.1274023 3.06477923 6.93522077 2 8 8 14 14 8" transform="translate(8.000000, 8.000000) rotate(90.000000) translate(-8.000000, -8.000000)"/></svg>',
};

export { actionarrowBack as default };
